import { memo } from "react";
import { DataGridPremium, type DataGridPremiumProps } from '@mui/x-data-grid-premium';
import Box, { type BoxProps } from "@mui/material/Box";
import { Paginate, ROWS_PER_PAGE_OPTIONS } from "consts/table";
import { RequestQueryMapper } from "util/request-query-mapper";
import { useRepositoryContext } from "../Repository";
import type { BankingSDKLoggingRepository } from "./repository";
import { useColumns } from "./support";

const BankingSDKLogging = (props: BoxProps) => {
    const repository = useRepositoryContext<BankingSDKLoggingRepository>();

    const onPageChange: DataGridPremiumProps['onPageChange'] = page => (
        repository.fetch(
            RequestQueryMapper.from()
                .contains(Paginate.page, `${page}`)
        )
    );

    const onPageSizeChange: DataGridPremiumProps['onPageSizeChange'] = pageSize => (
        repository.fetch(
            RequestQueryMapper.from()
                .contains(Paginate.perPage, `${pageSize}`)
        )
    );

    return (
        <Box
            {...props}
        >
            <DataGridPremium
                {...repository.tablePaginator}
                disableSelectionOnClick
                pagination
                paginationMode='server'
                rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                columns={useColumns()}
                rows={repository.rows}
                loading={repository.isRepositoryLoading}
                getRowId={({ createdDateTime }) => createdDateTime}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                initialState={{
                    pagination: repository.tablePaginator
                }}
            />
        </Box>
    );
};

export default memo(BankingSDKLogging);
